import type { Job } from "../../../models";
import type { Mission, Sample, Core } from "@rogoag/shared-ts";
import type { Robot } from "../../../models/rogo/Robot";

export interface OpsMapProps {
	jobs?: Job[];
	missions?: Mission[];
	robots?: Robot[];
	height?: number | string;
}

export type OpsPopup =
	| { type: "job"; lng: number; lat: number; job: Job }
	| { type: "sample"; lng: number; lat: number; sample: Sample }
	| { type: "core"; lng: number; lat: number; core: Core }
	| { type: "robot"; lng: number; lat: number; robot: Robot };

export interface VisibleLayers {
	jobs: boolean;
	missions: boolean;
	robots: boolean;
}

export type MissionPointView = "samples" | "cores" | "all";

export const OPS_COLORS = {
	missionPolygonFill: "#9c27b0",
	missionPolygonStroke: "#7b1fa2",
	missionLine: "#ff9800",
	robotTrail: "#ff1a1a",
	robotPoint: "#4caf50",
} as const;
